export default __webpack_public_path__ + "static/media/DtVkJx26TKEr37c9aBBxQlgc5yjTjQJElti5.7cc0124c.woff2";